import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";

/** code generate by generateapi don't edit */
import { getClient } from './internal'; // @error:
// alipay.ErrInvalidRequest 参数错误
// account.ErrProfileNotFound 没有找到用户资料
// ossreport.ErrInvalidRequestData invalid request data
// svr options: (ext.CmdID) = 1

/** @type {(r: accountlogic.LoginReq, b: any) => Promise<accountlogic.LoginRes>} TypeScript syntax */

export function Login(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/accountlogic/Login",
    "auth": "1"
  }), o));
}
; // @error:
// alipay.ErrInvalidRequest 参数错误
// account.ErrProfileNotFound 没有找到用户资料
// ossreport.ErrInvalidRequestData invalid request data
// svr options: (ext.CmdID) = 2

/** @type {(r: account.GetProfileReq, b: any) => Promise<account.GetProfileRes>} TypeScript syntax */

export function GetProfile(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/accountlogic/GetProfile",
    "auth": "1"
  }), o));
}
; // @error:
// alipay.ErrInvalidRequest 参数错误
// account.ErrProfileNotFound 没有找到用户资料
// ossreport.ErrInvalidRequestData invalid request data
// svr options: (ext.CmdID) = 3

/** @type {(r: accountlogic.SetProfileReq, b: any) => Promise<accountlogic.SetProfileRes>} TypeScript syntax */

export function SetProfile(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/accountlogic/SetProfile",
    "auth": "1"
  }), o));
}
; // @error:
// account.ErrAppNotFound 没有找到应用
// svr options: (ext.CmdID) = 4

/** @type {(r: account.GetAppReq, b: any) => Promise<account.GetAppRes>} TypeScript syntax */

export function GetApp(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/accountlogic/GetApp",
    "auth": "1"
  }), o));
}
; // svr options: (ext.CmdID) = 5

/** @type {(r: account.SetAppReq, b: any) => Promise<account.SetAppRes>} TypeScript syntax */

export function SetApp(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/accountlogic/SetApp",
    "auth": "1"
  }), o));
}
; // svr options: (ext.CmdID) = 7

/** @type {(r: account.ListAppReq, b: any) => Promise<account.ListAppRes>} TypeScript syntax */

export function ListApp(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/accountlogic/ListApp",
    "auth": "1"
  }), o));
}
; // svr options: (ext.CmdID) = 6

/** @type {(r: accountlogic.SaasLoginReq, b: any) => Promise<ext.RawRsp>} TypeScript syntax */

export function SaasLogin(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/accountlogic/SaasLogin",
    "auth": "1"
  }), o));
}
; // @error:
// ErrWrongPassword 密码错误
// ossreport.ErrInvalidRequestData invalid request data
// svr options: (ext.CmdID) = 8

/** @type {(r: accountlogic.ChangePasswordReq, b: any) => Promise<accountlogic.ChangePasswordRsp>} TypeScript syntax */

export function ChangePassword(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/accountlogic/ChangePassword",
    "auth": "1"
  }), o));
}
; // svr options: (ext.CmdID) = 9

/** @type {(r: accountlogic.LogoutReq, b: any) => Promise<accountlogic.LogoutRsp>} TypeScript syntax */

export function Logout(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/accountlogic/Logout",
    "auth": "1"
  }), o));
}
; // @error:
// ErrWrongPassword 密码错误
// account.ErrAccountNotFound 账号不存在
// ErrInvalidRequest 无效的请求
// svr options: (ext.CmdID) = 10

/** @type {(r: accountlogic.PinLoginReq, b: any) => Promise<accountlogic.PinLoginRsp>} TypeScript syntax */

export function PinLogin(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/accountlogic/PinLogin",
    "auth": "1"
  }), o));
}
; // svr options: (ext.CmdID) = 30
// svr options: (ext.UserType) = staff

/** @type {(r: account.DelProfilePhoneReq, b: any) => Promise<account.DelProfilePhoneRsp>} TypeScript syntax */

export function DelProfilePhone(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/accountlogic/DelProfilePhone",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 清除账号信息
// @desc:
// @error:
// svr options: (ext.CmdID) = 31
// svr options: (ext.UserType) = staff

/** @type {(r: account.DelAccountProfileReq, b: any) => Promise<account.DelAccountProfileRsp>} TypeScript syntax */

export function DelAccountProfile(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/accountlogic/DelAccountProfile",
    "auth": "1"
  }), o));
}
;
var AccountlogicServices = {
  Login: Login,
  GetProfile: GetProfile,
  SetProfile: SetProfile,
  GetApp: GetApp,
  SetApp: SetApp,
  ListApp: ListApp,
  SaasLogin: SaasLogin,
  ChangePassword: ChangePassword,
  Logout: Logout,
  PinLogin: PinLogin,
  DelProfilePhone: DelProfilePhone,
  DelAccountProfile: DelAccountProfile
};
export default AccountlogicServices;